import { cardsToShowLastFourOnRewardsBanner } from "redmond";

export const CARS_REWARDS_DISABLED_BANNER_TEXT =
  "Rewards redemptions are temporarily unavailable. Card purchases will still earn rewards normally.";

export const HOME_PAGE_BANNER_TEXT = ({
  firstName,
  earnRate,
  productId,
  lastFour,
  flightEarnRate,
  currency,
}: {
  firstName: string;
  earnRate: string | number;
  productId: string;
  lastFour: string;
  flightEarnRate: string | number;
  currency: string;
}) => {
  const multiplier = currency.includes("cash") ? "%" : "X";
  let earnString = flightEarnRate
    ? `Hi ${firstName}, earn ${flightEarnRate}${multiplier} ${currency} on flights and ${earnRate}${multiplier} ${currency} on hotels and rental cars when you book with your ${productId} account.`
    : `Hi ${firstName}, earn ${earnRate}${multiplier} ${currency} on hotels and rental cars when you book with your ${productId} account.`;
  earnString += cardsToShowLastFourOnRewardsBanner.includes(
    productId.toLowerCase()
  )
    ? `ending in ${lastFour}`
    : ``;
  return earnString;
};

export const CARS_SHOPPING_FUNNEL_BANNER_TEXT = ({
  firstName,
  earnRate,
  productId,
  lastFour,
  flightEarnRate,
  currency,
}: {
  firstName: string;
  earnRate: string | number;
  productId: string;
  lastFour: string;
  flightEarnRate: string | number;
  currency: string;
}) => {
  const multiplier = currency.includes("cash") ? "%" : "X";
  let earnString = flightEarnRate
    ? `Hi ${firstName}, earn ${flightEarnRate}${multiplier} ${currency} on flights and ${earnRate}${multiplier} ${currency} on hotels and rental cars when you book with your ${productId} account.`
    : `Hi ${firstName}, earn ${earnRate}${multiplier} ${currency} on hotels and rental cars when you book with your ${productId} account.`;
  earnString += cardsToShowLastFourOnRewardsBanner.includes(
    productId.toLowerCase()
  )
    ? `ending in ${lastFour}`
    : ``;
  return earnString;
};
